import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";

/** Both budget screens are the same height, so the dialog never resizes when you open a budget. */
export const BUDGET_SCREEN_HEIGHT = 560;

export const BUDGET_MANAGER_TITLE_ID = "insights-budget-manager-title";

interface BudgetManagerHeaderProps {
    title: string;
    onBack?: () => void;
    onClose: () => void;
    disabled?: boolean;
}

export function BudgetManagerHeader({title, onBack, onClose, disabled}: BudgetManagerHeaderProps) {
    const {t} = useTranslation();

    return (
        <Box sx={{display: "flex", alignItems: "center", gap: 1, px: 2, py: 1.5, minHeight: 56}}>
            {onBack != null && (
                <IconButton aria-label={t("Back")} onClick={onBack} disabled={disabled}>
                    <ArrowBackIcon/>
                </IconButton>
            )}

            <Typography
                id={BUDGET_MANAGER_TITLE_ID}
                component={"h2"}
                variant={"h6"}
                noWrap
                sx={{pl: onBack == null ? 1 : 0}}
            >
                {title}
            </Typography>

            <IconButton aria-label={t("Close")} onClick={onClose} disabled={disabled} sx={{ml: "auto"}}>
                <CloseIcon/>
            </IconButton>
        </Box>
    );
}

export default BudgetManagerHeader;
